var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"hotelMap"}}),_c('OrderCollectionOnDehalf',{ref:"collectionOnDehalf",attrs:{"collectionShow":_vm.collectionShow,"orderDetail":_vm.orderDetail},on:{"onShow":function($event){_vm.collectionShow=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }